// Phase 2D.2A — client-side resend cooldown.
//
// Stores ONE numeric expiry timestamp per flow in sessionStorage so the
// cooldown survives a refresh in the same tab. It never stores an e-mail
// address, a token, a password, an authorization code or a URL fragment, and it
// is only a usability guard: Supabase Auth rate limiting stays authoritative
// and the neutral anti-enumeration response is shown either way.

export const COOLDOWN_SECONDS = 60;

export const COOLDOWN_KEYS = Object.freeze({
  forgotPassword: "offertrace.cooldown.forgot_password_link",
  profilePasswordReset: "offertrace.cooldown.profile_password_link",
});

function store() {
  try {
    return typeof window === "undefined" ? null : window.sessionStorage;
  } catch (err) {
    return null;
  }
}

export function clearCooldown(key) {
  const s = store();
  if (!s) return;
  try {
    s.removeItem(key);
  } catch (err) {
    // Storage unavailable (private mode / disabled) — the cooldown is optional.
  }
}

export function readCooldown(key) {
  const s = store();
  if (!s) return 0;
  let raw = null;
  try {
    raw = s.getItem(key);
  } catch (err) {
    return 0;
  }
  if (!raw) return 0;
  const expiresAt = Number.parseInt(raw, 10);
  if (!Number.isFinite(expiresAt)) {
    clearCooldown(key);
    return 0;
  }
  const remaining = Math.ceil((expiresAt - Date.now()) / 1000);
  if (remaining <= 0) {
    clearCooldown(key);
    return 0;
  }
  return Math.min(remaining, COOLDOWN_SECONDS);
}

export function startCooldown(key) {
  const s = store();
  if (s) {
    try {
      s.setItem(key, String(Date.now() + COOLDOWN_SECONDS * 1000));
    } catch (err) {
      // Storage unavailable — the in-memory pending state still blocks resends.
    }
  }
  return COOLDOWN_SECONDS;
}
